<script>
  import { Checkbox } from "carbon-components-svelte";
  import { Button, Select, SelectItem } from "paxray-components-svelte";

  import TrashCan16 from "carbon-icons-svelte/lib/TrashCan16";

  export let newfilterstep = "";
  export let processSteps = [];
  export let filterCreate = {
    name: "",
    type: "",
    steps: [],
    col: "",
    value: "",
    comparison: "eq",
  };

  $: if (newfilterstep !== "") {
    newfilterstep = "";
  }
  $: if (!filterCreate.steps) {
    filterCreate.steps = [];
  }
</script>

<span>Process Start</span>
<img src="/img/assistant/icons/arrow_down_dark.svg" alt="" />
{#each filterCreate.steps as step, index}
  <div class="step">
    <Select hideLabel bind:selected={step}>
      <SelectItem value=".*" text="Any" />
      {#each Object.values(processSteps).sort() as processStep}
        <SelectItem value={processStep} text={processStep}></SelectItem>
      {/each}
    </Select>
    <Button
      size="field"
      kind="danger-tertiary"
      iconDescription="Delete"
      icon={TrashCan16}
      on:click={() => {
        filterCreate.steps.splice(index, 1);
        filterCreate = filterCreate;
      }}
    />
  </div>
{/each}
<Select bind:selected={newfilterstep}>
  <SelectItem value="" text="" />
  <SelectItem value=".*" text="Any" />
  {#each Object.values(processSteps).sort() as processStep}
    <SelectItem value={processStep} text={processStep}></SelectItem>
  {/each}
</Select>
<Checkbox bind:checked={filterCreate.invert} labelText="Invert filter"
></Checkbox>
<img src="/img/assistant/icons/arrow_down_dark.svg" alt="" />
<span>Process End</span>

<style>
  .step {
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
    align-items: center;
  }

  span {
    background-color: var(--pax-smoke);
    height: 3rem;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 1rem;
  }

  img {
    height: 1rem;
  }
</style>
